import { useViewport } from "@faire/web/common/hooks/useViewport";

export const useViewportValue = () => {
  const viewport = useViewport();

  if (viewport.isMobile) {
    return "mobile";
  }

  if (viewport.isTablet) {
    return "tablet";
  }

  return "desktopAndAbove";
};
